// 결제 수단 코드 → 명칭으로 변환하는 컴포넌트
// Main - 개인화영역 및 G코인 충전내역에서 사용함

const getPgpayMethodCode = (code: number, useDefaultDash?: boolean) => {
  switch (code) {
    case 2:
      return "신용카드";
    case 3:
      return "다날 휴대폰";
    case 6:
      return "가상계좌";
    case 12:
      return "이니시스 문화상품권";
    case 14:
      return "신용카드(자동결제)";
    case 20:
      return "자동이체(자동결제)";
    case 29:
      return "네이버페이";
    case 31:
      return "카카오페이";
    default:
      return useDefaultDash ? "-" : "미지정";
  }
};

export default function PaymentType({ code, useDefaultDash = false }: { code: number; useDefaultDash?: boolean }) {
  return getPgpayMethodCode(code, useDefaultDash);
}
